// Vendor
import { Component, input } from '@angular/core';

// Interfaces
import { BackgroundJobProgressUpdate } from 'NotificationsApp/ts/interfaces/background-job.interface';

@Component({
    standalone: false,
    selector: 'tr[ycn-background-jobs-progress-popover-item]',
    templateUrl: './background-jobs-progress-popover-item.template.html',
})
export class BackgroundJobsProgressPopoverItemComponent {
    showDescription: boolean = false;

    readonly progress = input.required<BackgroundJobProgressUpdate>();

    toggleShowDescription(): void {
        this.showDescription = !this.showDescription;
    }
}
